// src/components/Products.js
import React from 'react';
import Ideapng from '../resorcesfiles/images/idea.png';
import './Products.css';
import Mainmastet from '../masterpage/Mainmastet';
import P80 from '../resorcesfiles/ideak/p80.jpg'
import U300 from '../resorcesfiles/ideak/u300.jpg'
import Cp30 from '../resorcesfiles/ideak/cp30.jpg'
import C72 from '../resorcesfiles/ideak/c72.jpg'
import Antenna from '../resorcesfiles/ideak/antenna.jpg'
import Laundrytags from '../resorcesfiles/ideak/laundrytags.jpeg'
import Keyfob from '../resorcesfiles/ideak/keyfob.jpeg'
import AnimalTag from '../resorcesfiles/ideak/animaltag.png'
import CakeTag from '../resorcesfiles/ideak/caketag.jpg'
import { Helmet } from 'react-helmet-async';

import { Link } from 'react-router-dom';




const products = [

  {
    img:Laundrytags,
    shortName: '',
    fullName: 'Laundry Tags',
    description: 'WaterProof',
    paths:''
  },
  {
    img:Keyfob,
    shortName: 'UHF',
    fullName: '13.56mhz Mifare 1K Key Fob tag',
    description: 'Lightweight, harder and more durable',
    paths:''
  },
  {
    img:AnimalTag,
    shortName: '125 kHz',
    fullName: '125 kHz Glass Tube RFID Tag',
    description: 'Implanting into pets to laundry management.',
    paths:''
  },

  {
    img:CakeTag,
    shortName: '',
    fullName: 'RFID UHF Labels',
    description: 'Asset and Warehouse Application',
    paths:''
  },



];

const ProductsLabels = () => {
  return (
    <Mainmastet content={<>
    
            <Helmet>
                <title>RFID Solutions in Kenya | Ziditech</title>
                <meta 
                  name="description" 
                  content={`Explore advanced RFID Labels, Printers, and access systems in Kenya from Ziditech.`} 
                />
                <meta name="keywords" content={`RFID Labels`} />
              </Helmet>
    


    <div className="products-container">
        <div style={{textAlign:'center'}}>
        <h1 style={{fontFamily:'fantasy'}}>LABELS / TAGS</h1>
        </div>
      <div className="products-grid">
        {products.map((product, index) => (
        <Link key={index} className="product-item" style={{textDecoration:'none'}} > 
            <img src={product.img} alt={product.fullName} className="product-image" />
            {/* <h2 className="product-shortname">{product.shortName}</h2> */}
            <h3 className="product-fullname">{product.fullName}</h3>
            <p className="product-description">{product.description}</p>
        </Link>
    
        ))}
      </div>

      <div style={{height:'50px'}}></div>

    </div>

    </>} />
  );
};

export default ProductsLabels;
